/* UV THEME - cinematic behaviors */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  var header = document.querySelector('.header-wrapper');
  var ticking = false;
  function update() {
    if (header) {
      if ((window.scrollY || 0) > 40) { header.setAttribute('data-uv-scrolled', ''); }
      else { header.removeAttribute('data-uv-scrolled'); }
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();

  /* hero bg video: mobile browsers (esp. Chrome on Android with Data Saver,
     or after several reloads in one session) will sometimes silently refuse
     to autoplay even a muted/playsinline video - play() returns a rejected
     promise instead of throwing, so it fails invisibly. Retry a few times,
     and also retry on the first touch/scroll since that always counts as a
     user gesture and unblocks autoplay-blocked media. */
  var bgVideo = document.querySelector('[data-uvx-bgvideo]');
  if (bgVideo) {
    var tryPlay = function () {
      var p = bgVideo.play();
      if (p && p.catch) { p.catch(function () {}); }
    };
    tryPlay();
    bgVideo.addEventListener('loadeddata', tryPlay);
    bgVideo.addEventListener('canplay', tryPlay);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && bgVideo.paused) { tryPlay(); }
    });
    var gestureRetry = function () {
      if (bgVideo.paused) { tryPlay(); }
      window.removeEventListener('touchstart', gestureRetry);
      window.removeEventListener('scroll', gestureRetry);
      window.removeEventListener('click', gestureRetry);
    };
    window.addEventListener('touchstart', gestureRetry, { passive: true, once: true });
    window.addEventListener('scroll', gestureRetry, { passive: true, once: true });
    window.addEventListener('click', gestureRetry, { once: true });
  }

  if (reduce) return;

  var heroContent = document.querySelector('[data-uvx-entrance]');
  if (heroContent) {
    window.requestAnimationFrame(function () { heroContent.classList.add('uvx-in'); });
  }

  /* particle canvas: paused off-screen via IntersectionObserver so it doesn't
     burn frame budget while the user has scrolled past the hero (this was
     running an uncapped rAF loop forever, competing with scroll for frames) */
  var canvas = document.querySelector('[data-uvx-particles]');
  if (canvas && canvas.getContext && !isMobile) {
    var ctx = canvas.getContext('2d');
    var heroWrap = canvas.parentElement;
    var particles = [];
    var running = false;
    var rafId = null;
    var sizeCanvas = function () { canvas.width = heroWrap.clientWidth; canvas.height = heroWrap.clientHeight; };
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);
    var count = Math.min(40, Math.floor(window.innerWidth / 30));
    for (var i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.6 + 0.4,
        vx: (Math.random() - 0.5) * 0.15,
        vy: (Math.random() - 0.5) * 0.15,
        a: Math.random() * 0.4 + 0.1
      });
    }
    function loop() {
      if (!running) { rafId = null; return; }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(160,200,255,' + p.a + ')';
        ctx.fill();
      }
      rafId = window.requestAnimationFrame(loop);
    }
    if ('IntersectionObserver' in window) {
      var pObs = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        if (visible && !running) { running = true; if (!rafId) { rafId = window.requestAnimationFrame(loop); } }
        else if (!visible && running) { running = false; }
      }, { threshold: 0 });
      pObs.observe(heroWrap);
    } else {
      running = true; rafId = window.requestAnimationFrame(loop);
    }
  }

  var heroEl = document.querySelector('.uvx-hero');
  var floats = document.querySelectorAll('[data-uvx-float]');
  if (heroEl && floats.length && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var mx = 0, my = 0, fraf = null;
    var applyParallax = function () {
      fraf = null;
      floats.forEach(function (f) {
        var d = parseFloat(f.getAttribute('data-depth')) || 0.5;
        f.style.setProperty('--px', (mx * 34 * d).toFixed(1) + 'px');
        f.style.setProperty('--py', (my * 22 * d).toFixed(1) + 'px');
      });
    };
    heroEl.addEventListener('mousemove', function (e) {
      var r = heroEl.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5;
      my = (e.clientY - r.top) / r.height - 0.5;
      if (!fraf) { fraf = window.requestAnimationFrame(applyParallax); }
    });
    heroEl.addEventListener('mouseleave', function () {
      mx = 0; my = 0;
      if (!fraf) { fraf = window.requestAnimationFrame(applyParallax); }
    });
  }

  /* spotlight scrollers: progress clamped so the last card holds centred
     before the section unpins (no clipped tees mid-travel).
     Item width + gap are measured once (on init/resize) instead of every
     scroll frame - the previous version called getComputedStyle() and read
     offsetWidth inside the scroll handler, forcing a synchronous layout
     recalculation on every single scroll tick. That's the main cause of
     stutter on mobile: layout thrashing during the highest-frequency event
     on the page, compounded by two independent scroller instances. */
  var spots = document.querySelectorAll('[data-uvx-spot]');
  spots.forEach(function (spot) {
    var track = spot.querySelector('[data-uvx-spot-track]');
    var items = spot.querySelectorAll('[data-uvx-spot-item]');
    var bar = spot.querySelector('[data-uvx-spot-bar]');
    var n = items.length;
    if (!track || n === 0) return;

    var iw = 0, gap = 0;
    var measure = function () {
      iw = items[0].offsetWidth;
      var styles = getComputedStyle(track);
      gap = parseFloat(styles.columnGap || styles.gap) || 0;
    };
    measure();

    var sTick = false;
    var spotUpdate = function () {
      sTick = false;
      var rect = spot.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height - vh;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      var t = Math.min(1, p / 0.9);
      var idx = t * (n - 1);
      var x = (window.innerWidth / 2) - (iw / 2) - idx * (iw + gap);
      track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      items.forEach(function (it, i) {
        var d = Math.abs(i - idx);
        it.style.setProperty('--s', (1 - Math.min(d * 0.16, 0.4)).toFixed(3));
        it.style.setProperty('--op', (1 - Math.min(d * 0.45, 0.8)).toFixed(3));
        it.style.setProperty('--br', (1 - Math.min(d * 0.35, 0.6)).toFixed(3));
        it.style.setProperty('--meta', d < 0.4 ? (1 - d / 0.4).toFixed(3) : '0');
      });
      if (bar) { bar.style.setProperty('--p', t.toFixed(4)); }
    };
    window.addEventListener('scroll', function () {
      if (!sTick) { window.requestAnimationFrame(spotUpdate); sTick = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); spotUpdate(); });
    spotUpdate();
  });

  var revealTargets = document.querySelectorAll('.uvx-reveal');
  if ('IntersectionObserver' in window && revealTargets.length) {
    revealTargets.forEach(function (t) { t.classList.add('uvx-will'); });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('uvx-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    revealTargets.forEach(function (t) { obs.observe(t); });
  }
})();
